import React from 'react';
import PropTypes from 'prop-types';

const MaterialDropDown = ({className, id, name, value, onClick, label, data, itemValueFunc, itemTextFunc, showLabel=true, readOnly=true, ...rest}) => { 
    return (
        <div className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select ${className || ''}`}>
            <input className="mdl-textfield__input" type="text" id={id || name} name={name} value={value} readOnly={readOnly} {...rest} />
            <label htmlFor={name} className="mdl-textfield__label">{ showLabel ? (label || name) : '' }<span className="caret"/></label>
            <ul htmlFor={name} className="mdl-menu mdl-menu--bottom-left mdl-js-menu">
                {
                    data.map(dataItem =>
                        <li key={itemValueFunc ? itemValueFunc(dataItem) : dataItem} data-val={itemValueFunc ? itemValueFunc(dataItem) : dataItem} name={name} className="mdl-menu__item" onClick={(e) => onClick(e, dataItem)}>{itemTextFunc ? itemTextFunc(dataItem) : dataItem}</li>
                    )
                }                             
            </ul>
        </div>
    );
};

MaterialDropDown.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    label: PropTypes.string,
    itemValueFunc: PropTypes.func,
    itemTextFunc: PropTypes.func,
    readOnly: PropTypes.bool,
    id: PropTypes.string,
    onClick: PropTypes.func,
    data: PropTypes.array.isRequired,
    showLabel: PropTypes.bool
};

export default MaterialDropDown;